export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/alert-circle-yellow.c6d2a552.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};